import { useTranslations } from "providers";

import { ConfirmDialog, ConfirmDialogProps } from "./ConfirmDialog";

interface ConfirmUnsavedProps extends Omit<ConfirmDialogProps, "title" | "content" | "accept" | "cancel"> {
  title?: string;
  content?: string;
  accept?: string;
  cancel?: string;
}

export const ConfirmUnsaved: React.FC<ConfirmUnsavedProps> = ({ title, content, cancel, accept, ...props }) => {
  const i18n = useTranslations();
  title = title || i18n.Confirm_Title;
  content = content || i18n.Confirm_Content;
  cancel = cancel || i18n.Confirm_Cancel;
  accept = accept || i18n.Confirm_Discard;

  return <ConfirmDialog {...props} accept={accept} cancel={cancel} title={title} content={content} />;
};
